<template>
  <div id="page-about" class="team">
    <ContentHeader>
      <h6 class="header__meta-title">{{ $wp.metaTitle }}</h6>
      <h1 class="header__title">{{ $wp.header.title }}</h1>
      <h3 class="header__subtitle">
        <Icon id="chat" class="header__subtitle-icon" />
        <span class="header__subtitle-text">{{ $wp.header.subtitle }}</span>
      </h3>
    </ContentHeader>

    <ContentSplit id="mission" :title="$wp.intro.title" :image="$wp.intro.image">
      <ContentRaw :html="$wp.intro.content" />
    </ContentSplit>

    <ContentSection alt-background>
      <ul class="row -spread discovery">
        <li v-for="item in $wp.intro.items_items" :key="item.title" class="discovery__item">
          <figure class="discovery__image" :style="{ backgroundImage: `url(${item.image})` }" />
          <h4 class="discovery__title">{{ item.title }}</h4>
          <ContentRaw :html="item.content" />
        </li>
      </ul>
    </ContentSection>

    <ContentSection :title="$wp.actions.title">
      <div class="row">
        <article v-for="item in $wp.actions.items" :key="item.title" class="card">
          <figure class="card__image" :style="{ backgroundImage: `url(${item.image})` }" />

          <div class="card__content">
            <h5 class="card__title">{{ item.title }}</h5>
            <p>{{ item.text }}</p>
            <PageLink class="button -corner card__button" v-bind="item.link" />
          </div>
        </article>
      </div>
    </ContentSection>

    <ContentSection id="team" align-left flat-title :title="$wp.team.title">
      <ContentRaw :html="$wp.team.text" class="team__content" />

      <div class="row -align-center team__main">
        <figure
          class="row__item -span-4 team__main-image"
          :style="{ backgroundImage: `url(${$wp.team.main.image})` }"
        />

        <div class="row__item team__main-text">
          <h4 class="card__title">{{ $wp.team.main.name }}</h4>
          <h5 class="card__subtitle">{{ $wp.team.main.position }}</h5>
          <p>{{ $wp.team.main.text }}</p>
        </div>
      </div>

      <div class="row -wrap team__cards">
        <article v-for="{ card_main: card } in $wp.team.cards" :key="card.name" class="card">
          <figure class="card__image -team" :style="{ backgroundImage: `url(${card.image})` }" />

          <div class="card__content">
            <h4 class="card__title">{{ card.name }}</h4>
            <h5 class="card__subtitle">{{ card.position }}</h5>
            <p>{{ card.text }}</p>
          </div>
        </article>
      </div>
    </ContentSection>

    <ContentSection id="board" align-left flat-title :title="$wp.boardOfDirectors.title">
      <ContentRaw :html="$wp.boardOfDirectors.text" class="team__content" />

      <ul class="row -wrap -spread">
        <li v-for="(card, idx) in $wp.boardOfDirectors.members" :key="idx" class="team__member">
          <figure class="team__image" :style="{ backgroundImage: `url(${card.image})` }" />
          <h4 class="card__title">{{ card.name }}</h4>
          <h5 class="card__subtitle">{{ card.position }}</h5>
          <p>{{ card.company }}</p>

          <a :href="card.link" target="_blank" rel="noopener">
            <Icon id="cursor" class="team__member-link" />
          </a>
        </li>
      </ul>
    </ContentSection>

    <ContentSection id="consultatives">
      <header class="raw-html">
        <ContentTitle align-left flat>{{ $wp.advisory_comitees.title }}</ContentTitle>
        <p class="about__p">{{ $wp.advisory_comitees.description }}</p>
        <h3>{{ $wp.advisory_comitees.performance_workshop.title }}</h3>
        <ul>
          <li v-for="(actor, actorKey) in $wp.advisory_comitees.performance_workshop.actors" :key="actorKey">{{ actor.infos }}</li>
        </ul>
      </header>

      <Partners
        :title="$wp.advisory_comitees.showcase_workshop.title"
        :partners="$wp.advisory_comitees.showcase_workshop.partners"
      >
      </Partners>

      <Partners
        :title="$wp.advisory_comitees.promotion_workshop.title"
        :partners="$wp.advisory_comitees.promotion_workshop.partners"
      >
      </Partners>

      <footer class="raw-html about__section">
        <h3>{{ $wp.advisory_comitees.adoption_workshop.title }}</h3>
        <p>{{ $wp.advisory_comitees.adoption_workshop.description }}</p>
      </footer>
    </ContentSection>
  </div>
</template>

<script>
import { ContentSplit, ContentSection, ContentHeader, ContentRaw, ContentTitle } from '@/components/content'
import Partners from '@/components/partials/Partners.vue'

export default {
  name: 'About',
  contentKey: 'about',
  components: { ContentTitle, Partners, ContentSplit, ContentSection, ContentHeader, ContentRaw }
}
</script>
